import React, { Component } from 'react';
import defaultAvatar from '../../images/avatar.svg';
import moment from "moment";
import agent from "../../agent";
import PostAvatar from "../Post/PostAvatar";
import { getLabel } from "../../language";
import Slider from "react-rangeslider";
import undecidedImg from "../../images/undecided.svg";

export class CandidateVoteDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            commentList: [],
            personIDsList: [],
            isLoading: true,
        }
    }

    getComments = (electionType, personID) => {
        const { election } = this.props
        const { personIDsList } = this.state
        personIDsList.find(item => item === personID)
        if (!personIDsList.length) {
            agent.Elections.getCandidatesDetails(election.electionID, personID, electionType).then(res => {
                if (res) {
                    personIDsList.push(personID)
                    this.setState({
                        commentList: res,
                        isLoading: false,
                    })
                }
            }, err => {
                this.setState({
                    commentList: [],
                    isLoading: false,
                })
            })
        }
    };

    redirectPage = (path) =>{
        window.location.href=`/${path}`
    }

    render() {
        const { index, photoName, personID, gender, averageVote, vote, urlSlug, displayName,
            partyName, electionType, partyURLSlug, partyID, userInfo, partyPhotoName, isUndecided, anonymous } = this.props
        const { commentList, isLoading } = this.state
        let voteDate = moment(vote && vote.dateCreated).format("YYYY/MM/DD")
        return (
            <li key={index}>
                <div className={`main ${anonymous ? "election-candidates" : ""}`}>
                    <div className="poli-img">
                        {
                            isUndecided ?
                                <img src={undecidedImg} alt={undecidedImg}
                                    className="img-circle" style={{width:'128px',height:'128px'}} /> :
                                <img onError={e => e.target.src = defaultAvatar}
                                    src={partyPhotoName || photoName ? `/images/${electionType === "party" ? "parties" : "people"}/${electionType === "party" ? partyID : personID}/${electionType === "party" ? "" : "official/"}${electionType === "party" ? partyPhotoName : photoName}` : defaultAvatar}
                                    alt={partyPhotoName ? partyPhotoName : photoName}
                                    className="img-circle" style={{width:'128px',height:'128px'}} />
                        }
                    </div>
                    <div className="politician">
                        <div className="poli-info">
                            <span style={{left:"110px"}} className={`${parseInt(gender) === 1 && "female "}${parseInt(gender) === 2 && "male"}`} />
                            <div className="poliname">
                                {
                                    isUndecided ? getLabel(248) :

                                       ( <div>
                                            {electionType === "party" ? ( <h4 className="pointer-event" onClick={() => this.redirectPage(partyURLSlug)}>{partyName}</h4>) : <h4 className="pointer-event" onClick={() => this.redirectPage(urlSlug)}>{displayName}</h4>}
                                        </div>)


                                }
                            </div>
                            <h6 className="country">{electionType === "person" ? partyName : null}</h6>
                        </div>
                        <div className="vote-percent">{(averageVote && averageVote.percentagePerElection) ? (averageVote.percentagePerElection * 100).toFixed(2) : 0}%
                        </div>
                        <div className={`thumbvote${anonymous ? "-dark" : ""} d-flex flex-row`} style={{background:'transparent'}}>
                            {
                                !isUndecided ? <a className="comments-number collapsed" data-toggle="collapse"
                                    href={`#commentsundecided${index}`}
                                    role="button" aria-expanded="false"
                                    aria-controls={`commentsundecided${index}`}
                                    onClick={() => this.getComments(electionType === "person" ? "personIDs" : "partyIds", electionType === "person" ? personID : partyID)}>Details</a> : null
                            }
                        </div>
                    </div>
                </div>
                <div className={`${vote && vote.dateCreated ? "vote-input checked" : "vote-input"} is-voted-election`}>
                    <div>
                        <input type="radio" id={`vote416${index}`} name="radio-group"
                            onChange={() => { }}
                            onClick={!(vote && vote.dateCreated) ? () => this.props.isElectionVoteModel(this.props) : () => this.props.isElectionVoteModel(this.props)}
                            checked={vote && vote.dateCreated ? false : false}
                        />
                        <label htmlFor={`vote416${index}`} />
                    </div>
                    <div className="date">{voteDate.includes("/") ? voteDate : null}</div>
                </div>
                <div id={`commentsundecided${index}`} className={`${anonymous ? "bgl" : "bgw"} col-md-12 collapse ${index}`} aria-expanded={`false ${index}`}>
                    {commentList.length ? <h4 className={`${anonymous ? "cw" : ""}`}>{commentList.length} {getLabel(134)}</h4> : <h4 className={`${anonymous ? "cw" : ""}`}>{getLabel(134)}</h4>}
                    <div className="comments election-cmt">
                        {isLoading && <p className="loading-spinner">&nbsp;</p>}
                        {
                            (commentList || []).map((item, i) => {
                                return (
                                    <div className="comment" key={i}>
                                        <header>
                                            <div className="authorimage">
                                                <a>
                                                    <PostAvatar userName={userInfo[item.user && item.user.id] && userInfo[item.user.id].userName || ''} isAnonymous={item.anonymous} />
                                                </a>
                                            </div>
                                            <div className="articletitle">
                                                <div className="author">
                                                    <a href="#">{item.anonymous ? getLabel(284): item.user && item.user.displayName}</a></div>
                                                <div className="date m-1">{moment(item.dateCreated).fromNow()}</div>
                                                {
                                                    item.vision > 0 &&
                                                    <div className="row w-100">
                                                        <div className="col-sm-2">
                                                            <span>{getLabel(111)}({item.vision})</span>
                                                        </div>
                                                        <div className="col-sm-10">
                                                            <Slider min={0} max={10}
                                                                value={item.vision}
                                                                orientation="horizontal"
                                                            />
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    item.ability > 0 &&
                                                    <div className="row w-100">
                                                        <div className="col-sm-2">
                                                            <span>{getLabel(110)}({item.ability})</span>
                                                        </div>
                                                        <div className="col-sm-10">
                                                            <Slider min={0} max={10}
                                                                value={item.ability}
                                                                orientation="horizontal"
                                                            />
                                                        </div>
                                                    </div>
                                                }

                                                <div className="textcomment">
                                                    {item.comment}
                                                </div>
                                            </div>
                                        </header>
                                    </div>
                                )
                            })
                        }
                        {!commentList.length && !isLoading ? <div>{getLabel(247)}</div> : null}
                    </div>
                </div>
            </li>
        );
    }
}

export default CandidateVoteDetails
